
<div class="imp-modal">
    <div class="imp-modal-body">
        <p><ion-button fill="clear" *ngIf="!this.modalId.startsWith('service')" id="imp-modal-close-button" (click)="this.close()">
            <ion-icon slot="icon-only" class="imp-close-button-icon" name="close-circle"></ion-icon>
        </ion-button></p>
        <imp-privacy *ngIf="this.modalId.startsWith('privacy')"></imp-privacy>
        <imp-terms *ngIf="this.modalId.startsWith('terms')"></imp-terms>
        <imp-contact *ngIf="this.modalId.startsWith('contact')"></imp-contact>
        <imp-service *ngIf="this.modalId.startsWith('service')"></imp-service>
        <p><button *ngIf="this.modalId.startsWith('service')" id="imp-modal-decline-button" (click)="acceptTerms(false)">I do not agree to these terms</button></p>
        <p><button *ngIf="this.modalId.startsWith('service')" id="imp-modal-accept-button" (click)="acceptTerms(true)">I accept these terms</button></p>
    </div>
</div>
<div class="imp-modal-background"></div>




